import type { Editor } from 'slate';
import type { SlateBlock } from '@atlas/renderer';
import convertBlocksToOneLineTexts from '@atlas/tool/box/slate/convertBlocksToOneLineTexts';
import createCalloutBlock from '@atlas/tool/box/slate/createCalloutBlock';

export default function convertBlocksToCallouts(
    editor: Editor,
    options?: {
        match?: SlateBlock['type'] | ((node: SlateBlock) => boolean);
    },
) {
    if (!editor.selection) return;

    convertBlocksToOneLineTexts(editor, 'paragraph', {
        ...options,
        blockPatch: (block) => {
            if (block.type !== 'paragraph') return block;

            return createCalloutBlock(block.children);
        },
    });
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('convertBlocksToCallouts', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
